import React from 'react';
import { IM160ArticleFilterModule } from '~/lib/data-contract';
import { M160ArticleFilter } from './m160-article-filter';

export const M160ArticleFilterBlock = (props: IM160ArticleFilterModule) => {
    return <M160ArticleFilter {...props} />;
};
